<template>
  <el-dialog
    class="dialog-for-expiring"
    :visible.sync="dialogVisible"
    :class="device"
    width="600px"
    :top="undefined"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    append-to-body
  >
    <div slot="title">
      尊贵的PlayList会员用户：
    </div>
    <div>
      <div class="info-memberships">
        您的会员即将到期：
        <template v-if="device === 'pc'">
          <p v-for="(i, j) in membershipExpiringList" :key="j">
            【{{ i.goods_name }}】{{ i.last_days }}天后到期({{ i.expire_at }})
          </p>
        </template>
        <template v-if="device === 'mobile'">
          <p v-for="(i, j) in membershipExpiringList" :key="j">
            【{{ i.goods_name }}】<span>{{ i.expire_at }}到期</span>
          </p>
        </template>
      </div>

      <div class="info-material-authorization">
        <div class="info-material-authorization-title">
          <p v-if="device === 'pc' && certificates.length > 0">您有如下下载素材未激活授权书，请您在作品投放及会员到期前激活授权书，没有激活授权书的素材不可使用。</p>
          <p v-else-if="device === 'mobile' && certificates.length > 0">请您在作品投放及会员到期前去PC端激活授权书，没有激活授权书的素材不可使用；</p>
          <p v-else>请您按需要及时续购会员，PlayList将持续为您提供优质素材。</p>
        </div>

        <div v-if="device === 'pc' && certificates.length > 0" class="info-content">
          <ul>
            <li v-for="(i, j) in certificates" :key="j">{{ i.name }}</li>
          </ul>
        </div>
      </div>

    </div>
    <div class="btns-container">
      <el-button type="empty" @click="handleBeforeClose">我知道了</el-button>
      <el-button v-if="device === 'pc' && certificates.length > 0" type="primary" @click="handleCertificates">激活授权书</el-button>
      <el-button type="primary" @click="handleBuyPackage">续购会员</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ExpiringMembershipDialog",
  computed: {
    // 即将过期会员列表
    membershipExpiringList() {
      // return [
      //   {
      //     goods_name: '个人月度会员',
      //     last_days: '1',
      //     expire_at: '2022-04-24',
      //     certificates: [],
      //   },
      //   {
      //     goods_name: '个人月度会员',
      //     last_days: '1',
      //     expire_at: '2022-04-24',
      //     certificates: [],
      //   },
      //   {
      //     goods_name: '个人月度会员',
      //     last_days: '1',
      //     expire_at: '2022-04-24',
      //     certificates: [{}],
      //   }
      // ];
      return this.$store.state.user.membershipExpiringList.filter(i => !i.is_expired);
    },
    // 即将过期未授权列表
    certificates() {
      if (!(this.membershipExpiringList && this.membershipExpiringList.length > 0)) return []
      return this.membershipExpiringList.reduce(function(total, item) { return total.concat(item.certificates)}, []);
    },

    device() {
      return this.$store.state.user.device
    },
    dialogVisible: {
      get() {
        return this.$store.state.user.expiringDialogVisible;
      },
      set(val) {
        return this.$store.commit("user/UPDATE_EXPIRING_DIALOG_VISIBLE", val);
      }
    }
  },
  mounted() {
  },
  methods: {
    handleBeforeClose() {
      this.dialogVisible = false;
    },
    handleCertificates() {
      this.dialogVisible = false;
      this.$router.push('/member/center/authorized-download')
    },
    handleBuyPackage() {
      this.dialogVisible = false;
      this.$router.push('/package')
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-for-expiring {

  &.mobile {
    ::v-deep {
      .el-dialog {
        width: 76.6667vw!important;
        font-size: .32rem;
        border-radius: 3.2vw;
        background-image: url("./assets/bg-expired.png");
        background-size: 100% auto;
        background-position: 0 -0.1vw;
        background-repeat: no-repeat;
        margin-top: calc(50vh - 50%)!important;

        &:before {
          width: 100%;
          content: '温馨提示';
          display: block;
          position: absolute;
          top: 6.7vw;
          text-align: center;
          font-size: 5.3vw;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
        }

        .el-dialog__header {
          font-size: 4.2vw;
          padding-top: 22vw;
          padding-left: 5.3vw;
          padding-right: 5.3vw;
          padding-bottom: 1.6vw;
        }

        .info-memberships {
          font-size: 4.2vw;
          line-height: 5.3vw;
          font-weight: 400!important;
          span {
            line-height: 5.3vw;
          }
          p {
            line-height: 6vw;
            font-size: 4.2vw;
            text-indent: 1vw;

            &:first-of-type {
              margin-top: 1vw;
            }

            span {
              font-size: 3.5vw;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 0.6);
            }
          }
        }
        .info-material-authorization-title {
          font-size: 4.2vw;
          line-height: 6vw;
        }
        .el-dialog__body {
          padding-top: 0;
          padding-left: 5.3vw;
          padding-right: 5.3vw;
          padding-bottom: 4.2vw;
          line-height: 5.3vw;
        }

        .btns-container {
          text-align: center;
          padding-top: 5.1vw;
          margin: 0;

          .el-button {
            width: 26.666vw;
            height: 10.6vw;
            line-height: 10.2vw;
            border-radius: 0.533vw;
            font-size: 4vw;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            text-align: center;
            padding: 0;
            &+.el-button {
              margin-left: 5.3vw;
            }
            &.el-button--empty {
              background: #F5F6FA;
              border-color: #F5F6FA;
              color: #999999;
            }
          }
        }
      }
    }
  }
  ::v-deep {
    .el-dialog__header {
      padding: 23px 36px 0px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
    }

    .el-dialog__body {
      padding: 60px;
      padding-top: 18px;
      padding-bottom: 18px;
    }

    .el-button {
      padding: 0 24px;
      height: 36px;
      line-height: 36px;
      vertical-align: top;
      box-sizing: border-box;
    }
    .el-button--empty {
      border: 1px solid #E52A0D;
      border-radius: 2px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #E52A0D;
    }
  }

  .info-memberships {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 16px;
    margin-bottom: 7px;
    color: #333333;

    p {
      color: #E52A0D;
      text-indent: 1em;
      line-height: 24px;

      &:first-of-type {
        margin-top: 11px;
      }
    }
  }

  .btns-container {
    text-align: right;
    padding-top: 30px;
    padding-bottom: 14px;
    margin-right: -24px;
  }
  .info-material-authorization {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 24px;

    .info-material-authorization-title {

    }

    .info-content {
      width: 480px;
      max-height: 270px;
      background: #FFFFFF;
      margin-top: 8px;
      border: 1px solid #D9D9D9;
      box-shadow: 0px 1px 16px 0px rgba(0, 0, 0, 0.03);
      border-radius: 3px;
      padding: 12px 16px 2px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 12px;
      opacity: 0.8;
      overflow-y: auto;

      li {
        margin-bottom: 13px;
      }
    }
  }
}
</style>
